<h2 mat-dialog-title>Confirm</h2>

<mat-dialog-content>
<h4>{{data}}</h4>
</mat-dialog-content>

<mat-dialog-actions>
    <span class="example-spacer"></span>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button (click)="onYesClick()" [mat-dialog-close]="confirmed" cdkFocusInitial>YES</button>
</mat-dialog-actions>
